import { render, staticRenderFns } from "./ProductDetailList.vue?vue&type=template&id=1b81aa24"
import script from "./ProductDetailList.vue?vue&type=script&lang=js"
export * from "./ProductDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports